import { render } from "./Home.vue?vue&type=template&id=c87aa466"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&lang=stylus"
script.render = render

export default script